import styled from 'styled-components';

export const CarDetailSectionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;

  @media only screen and (max-width: 991px) {
    gap: 40px;
    flex-direction: column;
  }
`;

export const LeftSectionWrapper = styled.div`
  width: 100%;
  @media only screen and (max-width: 991px) {
    width: 100%;
  }
`;

export const RightSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 320px;

  @media only screen and (max-width: 991px) {
    padding-left: 0;
    width: 100%;
  }
`;

export const CarDetailListingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;

  @media only screen and (max-width: 768px) {
    gap: 20px;
  }
`;

export const BottomShareWrapper = styled.div`
  position: sticky;
`;
